// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface TermDTO extends EntitySelectorDTO { 
	id: string | null;
	name: string | null;
	startDate: moment.Moment | string;
}

const TermDTO = {
    className: 'TermDTO',
    create: (initValues?: Partial<TermDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			name: "",
			startDate: new Date(0).toISOString(),
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	startDate: 'startDate',
};

export default TermDTO;